import React, { useEffect, lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import SecureCorporateGate from "../guards/SecureCorporateGate";
import CustomLoading from "../../../Components/GeneralComponents/CustomLoading/customloading";
import { corporateNestedRoutes } from "./CorporateNestedRoutes";
import { corporateFeRouteTrace } from "../utils/corporateFeTrace";

const CorporateDashboardLayout = lazy(() => import("../layouts/CorporateDashboardLayout"));
const CorporateSearchLayout = lazy(() => import("../layouts/CorporateSearchLayout"));
const SearchPage = lazy(() => import("../pages/SearchPage"));
const SearchResultsPage = lazy(() => import("../pages/SearchResultsPage"));
const CorporatePackagePage = lazy(() => import("../package/CorporatePackagePage"));
const CorporatePackageCheckoutPage = lazy(() =>
  import("../package/checkout/CorporatePackageCheckoutPage"),
);

function CorporateChunkSuspense({ label, children }) {
  return (
    <Suspense fallback={<CustomLoading label={label} overlay size="large" />}>{children}</Suspense>
  );
}

function CorporateRouteEntry() {
  useEffect(() => {
    corporateFeRouteTrace("CorporateSecureRoutes mounted");
  }, []);
  return <SecureCorporateGate />;
}

/** Single SSOT corporate route branch — nest under top-level <Routes>, not inside splat wrapper. */
export const corporatePortalRoute = (
  <Route path="/p/company" element={<CorporateRouteEntry />}>
    <Route
      element={
        <CorporateChunkSuspense label="טוען חיפוש ארגוני...">
          <CorporateSearchLayout />
        </CorporateChunkSuspense>
      }
    >
      <Route
        path="search"
        element={
          <CorporateChunkSuspense label="טוען חיפוש...">
            <SearchPage />
          </CorporateChunkSuspense>
        }
      />
      <Route
        path="search/results"
        element={
          <CorporateChunkSuspense label="טוען תוצאות...">
            <SearchResultsPage />
          </CorporateChunkSuspense>
        }
      />
      <Route
        path="package/preview"
        element={
          <CorporateChunkSuspense label="טוען חבילה...">
            <CorporatePackagePage />
          </CorporateChunkSuspense>
        }
      />
      <Route
        path="package/:packageId/checkout"
        element={
          <CorporateChunkSuspense label="טוען השלמת הזמנה...">
            <CorporatePackageCheckoutPage />
          </CorporateChunkSuspense>
        }
      />
      <Route
        path="package/:packageId"
        element={
          <CorporateChunkSuspense label="טוען חבילה...">
            <CorporatePackagePage />
          </CorporateChunkSuspense>
        }
      />
    </Route>
    <Route
      element={
        <CorporateChunkSuspense label="טוען פורטל ארגוני...">
          <CorporateDashboardLayout />
        </CorporateChunkSuspense>
      }
    >
      {corporateNestedRoutes}
    </Route>
  </Route>
);
